import React from "react";
import Button from "components/Button";
import { UserRoundMinus, X } from "lucide-react";

const ConfirmPopup = ({
  onConfirm,
  onCancel,
  content = "Are you sure you want to remove the second traveller?",
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white p-6 border rounded-xl shadow-md w-[90%] max-w-sm">
        <h2 className="text-base font-semibold mb-4">{content}</h2>
        <div className="flex justify-end gap-2">
          <Button
            onClick={() => onCancel()}
            text="Close"
            iconEnd={<X size={18} />}
            className="text-secondary text-sm font-semibold px-[10px] py-[6px] border border-primary"
          />
          <Button
            onClick={() => onConfirm()}
            text="Remove"
            iconEnd={<UserRoundMinus size={18} />}
            className="text-red-500 text-sm font-semibold px-[10px] py-[6px] border border-red-500"
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
